import React, { Component, createRef } from 'react';
import parse from 'html-react-parser';

class Product extends Component {

    constructor(props) {
		super(props);
		this.state = {
			opened: false,
            firstCardHeight: 0,
		};
        this.container = createRef();
		this.toggleBox = this.toggleBox.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
	}

    state = {}

    componentDidMount() {
        let value = this.container.current.offsetHeight;
        this.setState({ firstCardHeight: value })
        // EventListener für Klicks
        document.addEventListener("mousedown", this.handleClickOutside);
    }

    componentWillUnmount() {
        // EventListener aufräumen
        document.removeEventListener("mousedown", this.handleClickOutside);
    }

    handleClickOutside(event) {
        if (
            this.state.opened &&
            this.container.current &&
            !this.container.current.contains(event.target)
        ) {
            this.setState({ opened: false });
        }
    }

    toggleBox() {
		const { opened } = this.state;
		this.setState({
			opened: !opened,
		});

        setTimeout(() => {
            this.setState({ height: this.container.current.offsetHeight });
            this.props.updateRowHeight(this.container.current.offsetHeight,this.props.index,this.state.firstCardHeight);
        }, 500);
	}

    customSubstring(str, length) {
        if (str.length <= length) {
            return str;
        }
    
        // Suche nach dem letzten Leerzeichen vor oder bei der gegebenen Länge
        let lastSpaceIndex = str.lastIndexOf(' ', length);
    
        // Wenn kein Leerzeichen gefunden wurde, schneide direkt ab
        if (lastSpaceIndex === -1) {
            return str.substring(0, length);
        }
    
        // Andernfalls schneide bis zum letzten Leerzeichen ab
        return str.substring(0, lastSpaceIndex);
    }

    render() { 

        var { title } = this.props;
        const { opened } = this.state;

		if (opened){
			title ='opened';
		}else{
			title ='closed';
		}

        return (
            <>
                <div className="col-md-4">
                    <div className={'card ' + title} ref={this.container}>
                        <div onClick={this.props.showDetail} className="card-img">
                            {this.props.item.label.length
                                ? <div className='label'>{this.props.item.label}</div>
                                : ''
                            }
                            {this.props.item.product.isProductSystem 
                                ? <img src={this.props.item.product.image} className="card-img-top system" alt="..." />
                                : <img src={this.props.item.product.image} className="card-img-top product" alt="..." />
                            }
                            
                        </div>
                        <div onClick={this.props.showDetail} className="card-body">
                            <div className='card-text'>
                                <h4 className="title">{this.props.item.product.title}</h4>
                                <p className='short-description'>{this.props.item.product.shortDescription}</p>
                                
                                    
                                    {/* IF item.description */}
                                    {this.props.item.description.length && this.state.opened
                                        ? <><p className="description item-descr">{parse(`${this.props.item.description}`)}</p></>
                                        : (
                                            <>
                                                {/* IF product.productfinderDescription */}
                                                {this.props.item.product.productfinderDescription.length && this.state.opened
                                                    ? <><div className="description prod-prodfinder-descr">{parse(`${this.props.item.product.productfinderDescription}`)}</div></>
                                                    : (
                                                        <>
                                                            {/* IF product.descriptionOnline */}
                                                            {this.props.item.product.descriptionOnline.length && this.state.opened
                                                                ? <><p className="description prod-descr-online">{parse(`${this.props.item.product.descriptionOnline}`)}</p></>
                                                                : (
                                                                    <>
                                                                        {/* IF product.description */}
                                                                        {this.props.item.product.description.length && this.state.opened
                                                                            ? <><p className="description prod-descr">{parse(`${this.props.item.product.description}`)}</p></>
                                                                            : ''
                                                                        }
                                                                    </>
                                                                )
                                                            }
                                                        </>
                                                    )
                                                }
                                            </>
                                        )
                                    }                   

                                    {/* {this.props.item.product.descriptionOnline.length
                                        ? (
                                                <>
                                                    {this.state.opened
                                                        ? parse(`${this.props.item.product.descriptionOnline}`)
                                                        : parse(this.customSubstring(`${this.props.item.product.descriptionOnline}`,200))
                                                    }
                                                </>
                                        )
                                        : (
                                            <>
                                                {this.state.opened
                                                    ? parse(`${this.props.item.product.description}`)
                                                    : parse(this.customSubstring(`${this.props.item.product.description}`,200))
                                                }
                                            </>
                                        )
                                    } */}
                                    
                            </div>
                        </div>
                        
                        {this.props.item.description.length || 
                        this.props.item.product.productfinderDescription.length || 
                        this.props.item.product.descriptionOnline.length || 
                        this.props.item.product.description.length
                            ? <button className="showMore" onClick={this.toggleBox} />
                            : ''
                        }

                    </div>
                </div>
                {this.state.opened
                    ? <div className="bg_overlay"></div>
                    : ''
                }
            </>
        );
    }
}
 
export default Product;